/** The chat's GIF of the year: the one everyone sent most, and who sent it most. */

import type { BlobSpec } from "../../story/stage";
import type { Chat } from "../../types";
import { GifSpotlight } from "../GifSpotlight";
import { count } from "../shared";

const BLOBS: BlobSpec[] = [
  { colour: "green", x: 60, y: 300, r: 190, seed: 34.2, wob: 0.2 },
  { colour: "blurple", x: 1010, y: 1800, r: 280, seed: 35.6, wob: 0.18 },
];

export function ChatGif({ gif }: { gif: NonNullable<Chat["gif"]> }) {
  return (
    <GifSpotlight
      gif={gif}
      blobs={BLOBS}
      kicker="The chat's GIF of the year"
      lead="Everyone's favourite reply"
      line={
        <>
          Sent <b>{count(gif.count)}</b> times. Mostly by <b>{gif.by}</b>.
        </>
      }
    />
  );
}
